import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { cartContext } from 'contexts/cartContext';
import { useCustomer } from 'hooks/useCustomer';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import useTimer from 'hooks/useTimer';
import { getUri } from 'services/generic';
import { GTM_PAGE_OTHER } from 'settings/gtm/gtmPageView';

import styles from './page.module.scss';

export default function LogOut(): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { logout } = useCustomer();
  const { resetPrivilegeCode } = useContext(cartContext);
  const { time } = useTimer({
    duration: 5000,
    interval: 1000,
    callback: () => {
      navigate(getUri('/'));
    },
  });

  useGtmPageView(GTM_PAGE_OTHER, '');

  useEffect(() => {
    logout().then(() => {
      localStorage.removeItem('user_login_type');
      resetPrivilegeCode();
    });
  }, []);

  return (
    <div className={styles.content}>
      <Helmet>
        <title>
          {t('META_TITLE_TEMPLATE', { title: t('LOGOUT_META_TITLE') })}
        </title>
      </Helmet>
      <div>{t('LOGOUT_TITLE')}</div>
      <div>{t('LOGOUT_TEXT', { count: time / 1000 })}</div>
    </div>
  );
}
